import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import { SortableElement } from 'react-sortable-hoc'
import OptionButton from '../../../../components/OptionButton'

const OptionItem = ({
	className,
	disabled,
	loading,
	id,
	onClick,
	value,
	onChange,
	onDelete,
	deletable,
	type,
	checked,
	draggable,
	gridWidth,
	autoFocus,
	placeholder,
}) => {
	return (
		<Grid className="q-button-container" item xs={12} sm={gridWidth}>
			<OptionButton
				className={className}
				disabled={disabled}
				loading={loading}
				id={id}
				onClick={onClick}
				value={value}
				onChange={onChange}
				onDelete={onDelete}
				deletable={deletable}
				type={type}
				checked={checked}
				draggable={draggable}
				autoFocus={autoFocus}
				placeholder={placeholder}
			/>
		</Grid>
	)
}

OptionItem.propTypes = {
	className: PropTypes.string,
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	value: PropTypes.string,
	disabled: PropTypes.bool,
	loading: PropTypes.bool,
	onClick: PropTypes.func,
	onChange: PropTypes.func,
	onDelete: PropTypes.func,
	deletable: PropTypes.bool,
	type: PropTypes.oneOf(['button', 'checkbox']),
	checked: PropTypes.bool,
	draggable: PropTypes.bool,
	gridWidth: PropTypes.number,
	autoFocus: PropTypes.bool,
	placeholder: PropTypes.string,
}

export default SortableElement(OptionItem)
